import { mutatorAction } from 'satcheljs';
import store from '../store/store';

/**
 * Mutator triggered when we discard changes to option.
 */
export default mutatorAction('discardExternalImagesOption', () => {
    store().selectedOption = null;
});
